/* Copyright (c) 2022 chilled.dev */

import Loader from 'components/loader';
import {
  GoogleAuthProvider,
  onAuthStateChanged,
  signInWithRedirect,
  User,
} from 'firebase/auth';
import {
  createContext,
  FC,
  ReactNode,
  startTransition,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useFirebase } from './firebase';

const FirebaseAuthContext = createContext<User | undefined>(undefined);

const FirebaseAuthProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const firebase = useFirebase();

  const [user, setUser] = useState<User>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({
      login_hint: 'user@grips.dev',
    });
    firebase.auth.useDeviceLanguage();
    onAuthStateChanged(firebase.auth, async (user) => {
      if (user) {
        console.log('logged in', user);

        const idToken = await user.getIdToken();

        console.log('idToken', idToken);

        const response = await fetch('/api/token', {
          method: 'POST',
          body: JSON.stringify({ idToken }),
          headers: {
            'Content-Type': 'application/json',
          },
        });
        const result = await response.json();
        console.log('result', result);

        if (result.isNew) {
          const newToken = await firebase.auth.currentUser?.getIdToken(true);
          console.log('newToken', newToken);
        }

        startTransition(() => {
          setUser(user);
          setIsLoading(false);
        });
      } else {
        console.log('not logged in, signing in');
        signInWithRedirect(firebase.auth, provider);
      }
    });
  }, [firebase.auth]);

  return (
    <FirebaseAuthContext.Provider value={user}>
      {user && children}
      {isLoading && <Loader />}
    </FirebaseAuthContext.Provider>
  );
};

const useFirebaseAuth = () => useContext(FirebaseAuthContext);

export { FirebaseAuthProvider, FirebaseAuthContext, useFirebaseAuth };
